import axios from 'axios';
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem('token');

export const fetchCoachData = async () => {
  try {
    const response = await axios.get(`${BACKEND}/allcoach`,{
      headers: {
        Authorization: `Bearer ${token}`, 
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Error fetching coach data');
  }
};


export const fetchOnlyCoachData = async () => {
  try {
    const response = await axios.get(`${BACKEND}/coach`,{
      headers: {
        Authorization: `Bearer ${token}`, 
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Error fetching coach data');
  }
};


export const verifyCoach = async (coachId) => {
  try {
    const response = await axios.patch(`${BACKEND}/verify-coach/${coachId}`);
    return response.data;
  } catch (error) {
    console.error('Error verifying coach:', error.response ? error.response.data : error);
    throw error;
  }
};


export const addCoach = async (formData) => {
  try {
    const response = await axios.post(`${BACKEND}/addcoachfromadmin`,formData,{

    });
    return response.data;
  } catch (error) {
    throw new Error('Error adding coach data');
  }
};


export const updateCoach = async (formData) => {
  console.log("formData",formData)

  try {
    const response = await axios.put(`${BACKEND}/editcoachfromadmin`,formData,{
      headers: {
        Authorization: `Bearer ${token}`, 
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Error fetching coach data');
  }
};
